export const ModuleSet = [
    'announcement','auth','common','course','forum','guest','home','message',
    'profile','quizes','reports','review','students','users','video','webinar','promoCode','notification','newsLetter','document','questions'
  ];